import styled from 'styled-components';

const StyledAllocations = styled.section`
    display: ${(props) => (props.isShown ? 'block' : 'none')};
     padding-top: 10px;

    .allocatedType {
        font-size: 14px;
        color: var(--brand);
        font-weight: bold;
        text-transform: uppercase;
    }
    
    .allocatedStatus {
        font-weight: bold;
    }

    .cancel-btn {
        padding: 5px 30px !important;
        border-radius: 5px;
        font-size: 16px;
        font-weight: 500;

        &:disabled {
            background: silver
        }
    }

    .address-column {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 13px;
        
        a {
            display: block;
            font-size: 12px;
        }

        button {
            padding: 0;
            line-height: 1;

            svg {
                width: 14px;
            }
        }
    }
`;

export default StyledAllocations;
